import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";
import { buildCompanyOfficeSelectOptions } from "../../../utils/companyOfficeLabel";

const sortByLabel = (options = []) =>
	[...options].sort((a, b) =>
		String(a.label ?? "").localeCompare(String(b.label ?? ""), undefined, {
			sensitivity: "base",
		})
	);

const mapSelectOptions = (items = [], labelKey, valueKey) =>
	sortByLabel(
		items
			.filter((item) => item?.[valueKey] != null && item?.DataStatus !== 0)
			.map((item) => ({
				label: String(item[labelKey] ?? item[valueKey] ?? "").trim(),
				value: item[valueKey],
			}))
			.filter((item) => item.label)
	);

export function useCompOffScopeOptions() {
	const dispatch = useDispatch();
	const masterData = useSelector((state) => state.masters?.masters);
	const loading = useSelector((state) => state.masters?.loading);

	useEffect(() => {
		dispatch(getAllMaster());
	}, [dispatch]);

	return useMemo(
		() => ({
			loading: Boolean(loading),
			offices: buildCompanyOfficeSelectOptions(masterData),
			departments: mapSelectOptions(
				masterData?.DepartmentMaster,
				"DepartmentName",
				"DepartmentId"
			),
			designations: mapSelectOptions(
				masterData?.DesignationMaster,
				"DesignationName",
				"DesignationId"
			),
			employeeTypes: sortByLabel(
				(masterData?.EmploymentTypeMaster || []).map((item) => ({
					label: String(
						item.EmploymentTypeName ?? item.EmploymentTypeId ?? ""
					).trim(),
					value: item.EmploymentTypeId,
				}))
			),
		}),
		[loading, masterData]
	);
}
